<template>
  <div class="order-box">
    <div class="address-no-content" v-if="!hasAddress" @click="navToaddressManagement">
      <div class="address-no">
        <van-icon name="plus" /> 还没有收货地址，去添加
      </div>
    </div>
    <div class="address" v-else @click="navToaddressManagement">
      <!-- <div> -->

      <img class="address-img" src="../../assets/index/address_img.png" alt="">
      <div class="address-name">
        <div class="name">{{orderInfo.checkedAddress.name}} {{orderInfo.checkedAddress.mobile}} <span class="tag" v-if="orderInfo.checkedAddress.isDefault">默认</span></div>
        <div class="address-text">{{orderInfo.checkedAddress.address}}</div>

      </div>
      <!-- </div> -->

      <!-- <div class="address-phone">
        <div class="phone">{{orderInfo.checkedAddress.mobile}}</div>
        <div class="address-text">{{orderInfo.checkedAddress.address}}</div>
      </div> -->
      <van-icon class="arrow-next" name="arrow" />
      <!-- <span class="next">></span> -->

    </div>
    <div class="coupon" v-if="orderInfo" @click="navToMyCoupon">
      <div class="coupon-text">优惠券</div>
      <div class="coupon-price">
        <div>￥{{orderInfo.couponPrice}}</div>
        <van-icon class="arrow-next" name="arrow" />
      </div>
    </div>
    <van-field class="leaving-message" v-model="submitInfo.message" rows="1" autosize type="textarea" placeholder="如需要，请输入留言" />
    <div class="order-info" v-if="orderInfo != null">
      <van-field class="detail" readonly label="商品合计" :value="'￥'+orderInfo.goodsTotalPrice" input-align="right" />
      <van-field class="detail" readonly label="运费" :value="'￥'+orderInfo.freightPrice" input-align="right" />
      <van-field class="detail" readonly label="优惠券" :value="'￥'+orderInfo.couponPrice" input-align="right" />
    </div>

    <div class="product-list" v-if="orderInfo != null">
      <van-card v-for="(item,index) in orderInfo.checkedGoodsList" :key="index" :thumb="item.picUrl">
        <template #desc>
          <div class="product-item">
            <div class="select-data">{{item.goodsName}}</div>
            <div class="select-guige">
              <div class="select-guige-item" v-for="(goods,idx) in item.specifications" :key="idx">{{goods}}</div>
            </div>
            <div class="price-number">
              <div>￥{{item.price}}</div>
              <div>x{{item.number}}</div>
            </div>

          </div>

        </template>
      </van-card>
    </div>

    <van-submit-bar v-if="orderInfo" :price="orderInfo.actualPrice*100" button-text="下单" @submit="onSubmit" />

  </div>

</template>

<script>
import { cartCheckout, orderSubmit } from "@/api/index";
import { Toast } from "vant";
// import axios from "axios";
// import itemInfo from "@/components/itemInfo";
import { Dialog } from "vant";

export default {
  name: "orderPage",

  data() {
    return {
      hasAddress: false,
      value: "",
      orderInfo: null,
      submitInfo: {
        cartId: this.$route.query.cartId || 0,
        addressId: 0,
        couponId: 0,
        message: "",
        grouponRulesId: 0,
        grouponLinkId: 0,
      },
      cartCheckoutData: {
        cartId: this.$route.query.cartId || 0, //购物车id	是	[string]	0	查看
        addressId: sessionStorage.getItem("addressId") || 0, //	地址id	是	[string]	0	查看
        couponId: sessionStorage.getItem("couponId") || 0, //	优惠id	是	[string]	0	查看
        grouponRulesId: 0, //	优惠规则id
      },
    };
  },
  updated() {
    this.$nextTick(function () {
      this.$el.scrollTop = this.$route.meta.scrollTop;
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollIndex, true);
    if (sessionStorage.getItem("addressId") != undefined) {
      this.cartCheckoutData.addressId = sessionStorage.getItem("addressId");
    } else if (sessionStorage.getItem("couponId") != undefined) {
      this.cartCheckoutData.couponId = sessionStorage.getItem("couponId");
    }
    cartCheckout(this.cartCheckoutData).then((res) => {
      if (res.data.errno == 0) {
        this.orderInfo = res.data.data;
        if (this.orderInfo.addressId != 0) {
          this.hasAddress = true;
        }
        this.submitInfo = {
          cartId: 0,
          addressId: res.data.data.addressId,
          couponId: res.data.data.couponId,
          message: this.submitInfo.message,
          grouponRulesId: res.data.data.grouponRulesId,
          grouponLinkId: 0,
        };
      }
    });
  },
  destroyed() {
    //移除当前页面的监听，App不能重复添加监听
    window.removeEventListener("scroll", this.handleScrollIndex);
  },

  methods: {
    handleScrollIndex() {
      this.$route.meta.scrollTop = this.$el.scrollTop;
    },
    navToMyCoupon() {
      this.$router.push({
        path: "/selectCoupon",
        query: {
          cartCheckoutData: JSON.stringify(this.cartCheckoutData),
        },
      });
    },
    onSubmit() {
      sessionStorage.removeItem("addressId");
      sessionStorage.removeItem("couponId");
      if (this.$route.query.cartId) {
        this.submitInfo.cartId = this.$route.query.cartId;
      }
      orderSubmit(this.submitInfo).then((res) => {
        console.log(res);
        if (this.hasAddress == false) {
          Toast("请先添加地址");
          return;
        }

        if (res.data.errno == 0) {
          this.$router.push({
            path: "/type/payment",
            query: {
              orderId: res.data.data.orderId,
              price: this.orderInfo.orderTotalPrice,
            },
          });
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });

      // },
    },
    navToaddressManagement() {
      this.$router.replace({
        path: "/selectAddress",
        query: {
          cartId: this.$route.query.cartId,
        },
      });
    },
    onClickButton() {
      this.$router.push({
        path: "/result",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .type-box-detail {
  overflow: hidden;
}
.order-box {
  height: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
  // overflow-y: scroll;
  background: #f4f4f4;
  padding-bottom: 10rem;
  .address-no-content {
    box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    width: 95.2%;
    margin: 1rem auto;
    height: 6.4rem;
    box-sizing: border-box;
    padding-left: 1.69rem;
    display: flex;
    align-items: center;
    background: url("../../assets/index/address_icon.png") left top no-repeat;
    background-size: 100% 0.6rem;
    background-color: #ffffff;

    .address-no {
      font-family: PingFangSC-Regular;
      font-size: 1.6rem;
      color: #424242;
      letter-spacing: 0;
      text-align: center;
      line-height: 1.6rem;
      display: flex;
      align-items: center;
      i {
        margin-right: 0.5rem;
      }
    }
  }
  .address {
    position: relative;
    box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    width: 95.2%;
    margin: 1rem auto;
    height: 8.4rem;
    box-sizing: border-box;
    padding-left: 1.69rem;
    padding-right: 1.69rem;
    display: flex;
    align-items: center;
    // line-height: 5rem;
    text-align: left;
    background: url("../../assets/index/address_icon.png") left top no-repeat;
    background-size: 100% 0.6rem;
    background-color: #ffffff;
    justify-content: space-between;

    .address-no {
      width: 100%;
      color: #999;
    }
    .address-img {
      height: 3.2rem;
      width: 3.2rem;
    }
    .address-name {
      display: inline-block;
      margin-right: 3rem;
      margin-left: 1.2rem;
      width: 62%;
      .name {
        font-family: PingFangSC-Regular;
        font-size: 1.4rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.4rem;
        .tag {
          background-image: linear-gradient(90deg, #fde58b 0%, #f8d268 100%);
          border-radius: 2px;
          padding: 0.2rem 0.6rem;
          font-family: PingFangSC-Regular;
          font-size: 1rem;
          color: #78470c;
          letter-spacing: 0;
          line-height: 1rem;
        }
      }
      .address-text {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.6rem;
        margin-top: 0.8rem;
      }
    }
  }
  .coupon {
    background: #ffffff;
    box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    width: 95.2%;
    margin: 0 auto 1rem;
    height: 4.4rem;
    box-sizing: border-box;
    padding-left: 1.69rem;
    padding-right: 1.69rem;

    display: flex;
    align-items: center;
    justify-content: space-between;
    .coupon-text {
      font-size: 1.6rem;
    }
    .coupon-price {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      text-align: right;
      div {
        margin-left: 0.5rem;
      }
    }
  }
  .leaving-message {
    width: 95.2%;
    margin: 0 auto 1rem;
    box-sizing: border-box;
    padding-left: 1.69rem;
    padding-right: 1.69rem;
    background: #fff;
    box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #424242;
    letter-spacing: 0;
    .van-field__control::placeholder {
      color: #424242;
    }
  }
  .order-info {
    width: 95.2%;
    margin: 0 auto 1rem;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
  }
  .product-list {
    width: 95.2%;
    margin: 0 auto 1rem;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
    .product-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .select-data {
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        line-height: 1.4rem;
        padding-left: 1rem;
        text-align: left;
      }
      .select-guige {
        background: #f7f7f7;
        border-radius: 2px;
        padding: 0.6rem;
        display: inline-block;
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #9c9c9c;
        letter-spacing: 0;
        line-height: 1.2rem;
        margin-left: 1rem;
        margin-top: 0.8rem;
      }
      .price-number {
        display: flex;
        justify-content: space-between;
        margin-top: 1.6rem;
        padding-left: 1rem;
        box-sizing: border-box;
        width: 100%;
        div:first-child {
          font-family: PingFangSC-Regular;
          font-size: 1rem;
          color: #fe5845;
          letter-spacing: 0;
          line-height: 1.4rem;
        }
        div:last-child {
          opacity: 0.5;
          font-family: PingFangSC-Regular;
          font-size: 1.2rem;
          color: #424242;
          letter-spacing: 0;
          line-height: 1.4rem;
        }
      }
    }
  }
  .select-data:last-child {
    margin-top: 1.3rem;
  }
}
/deep/ .van-field__label {
  text-align: left;
}
/deep/ .van-card {
  background: #fff;
}
/deep/ .van-submit-bar__text {
  text-align: left;
}
.arrow-next {
  font-size: 1.6rem;
}
/deep/ .van-submit-bar__button--danger {
  background: #d6be93;
}
/deep/ .van-tabs__line {
  width: 36px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/type/orderPage.vue